export const ANALYSIS_TYPES = {
  ar: [
    { value: "detailed", label: "تحليل مفصل" },
    { value: "summary", label: "ملخص تنفيذي" },
  ],
  en: [
    { value: "detailed", label: "Detailed Analysis" },
    { value: "summary", label: "Executive Summary" },
  ],
};

export const DATA_TYPES = {
  ar: [
    { value: "financial", label: "بيانات مالية" },
    { value: "non_financial", label: "بيانات غير مالية" },
  ],
  en: [
    { value: "financial", label: "Financial Data" },
    { value: "non_financial", label: "Non-Financial Data" },
  ],
};
